<div class="error-screen">
  <div class="error-card">
    <div class="browsi-header">
      <img [src]="'images/browsi-logo.png' | assetVersion">
    </div>

    <div class="greeting">Hi {{ userFirstName }},</div>

    <div class="no-workspace-message">
      We couldn’t load your InsightHub workspace
    </div>

    <div class="help-text">
      Please contact your account administrator to verify your permissions
    </div>

    <div class="user-info">
      (You're signed in as {{ userEmail }})
    </div>

    <button class="logout-button" (click)="logout()">Log out</button>
  </div>
</div>